import { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminForgot() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const normalizedEmail = (email || "").trim().toLowerCase();
      await api.post("/admin/request-reset", { email: normalizedEmail });
      setDone(true);
    } catch {
      // Even on error, present the same generic outcome — no enumeration.
      setDone(true);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto mt-20">
      <div className="panel-elev tick-brackets p-8">
        <div className="flex items-center gap-3 mb-6">
          <Mail className="w-5 h-5 text-[#00D2FF]" />
          <div>
            <div className="font-tech">Administrator</div>
            <h1 className="text-xl font-semibold text-white">Reset password</h1>
          </div>
        </div>
        {done ? (
          <div className="text-slate-300 text-sm" data-testid="admin-forgot-confirmation">
            If that address is on file, a single-use reset link has been sent. It expires in 30 minutes.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="admin-forgot-form">
            <div>
              <label className="label-cad">Administrator email</label>
              <input className="input-cad" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-forgot-email" autoComplete="username" required />
            </div>
            <button className="btn-primary w-full justify-center" disabled={loading} data-testid="admin-forgot-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
            </button>
          </form>
        )}
        <div className="mt-6 text-center">
          <a href="/admin/login" className="text-xs font-mono uppercase tracking-widest text-slate-400 hover:text-[#00D2FF]">Back to sign in</a>
        </div>
      </div>
    </div>
  );
}
